((Redactor) => {
  Redactor.add("plugin", "addbutton", {
    modals: {
      addbutton: `<form action="" id="addButtonForm" name="addButtonForm">
              <div class="form-item">
                  <label>## buttonLabel ##</label>
                  <input required type="text" name="cst_btn_label" id="label">
                  <span class="input-error"> </span>
              </div>
              <div class="form-item">
                  <label>## linkLabel ##</label>
                  <input required type="url" name="cst_btn_link" id="link">
                  <span class="input-error"> </span>
              </div>
              <div class="form-item">
                  <label>## colorLabel ##</label>
                  <select required class="custom-select" name="cst_btn_color" id="cst_btn_color">
                    <option value="btn_blue" selected> ## colorOne ## </option>
                    <option value="btn_green"> ## colorTwo ## </option>
                    <option value="btn_orange"> ## colorThree ## </option>
                  </select>
              </div>
          </form>`,
    },

    translations: {
      en: {
        addbutton: I18n.t('redactor_addbutton'),
        "addbutton-label": I18n.t('redactor_addbutton_label'),
        buttonLabel: I18n.t('redactor_button_label'),
        linkLabel: I18n.t('redactor_link_label'),
        colorLabel: I18n.t('redactor_color_label'),
        colorOne: I18n.t('redactor_color_one'),
        colorTwo: I18n.t('redactor_color_two'),
        colorThree: I18n.t('redactor_color_three'),
      },
    },

    init(app) {
      this.app = app;
      this.lang = app.lang;
      this.toolbar = app.toolbar;
      this.insertion = app.insertion;
      this.marker = app.marker;
      this.selection = app.selection;
    },

    onmodal: {
      addbutton: {
        opened: (modal, form) => {
          form.getField("cst_btn_label").focus();
        },
        insert(modal, form) {
          const addButtonForm = document.forms["addButtonForm"];
          const labelInp = addButtonForm.querySelector(".form-item #label");
          const linkInp = addButtonForm.querySelector(".form-item #link");
          let valid = false;

          for (let i = 0; i < addButtonForm.length; i++) {
            const formText = addButtonForm[i].id;
            const formItem = document.querySelectorAll(
              "#addButtonForm .form-item"
            )[i];
            const span = formItem.querySelector("span.input-error");
            if (addButtonForm[i].value !== "") {
              if (span) span.innerText = "";
            } else {
              span.innerText = `${formText} cannot be blank `;
            }
          }

          const linkElements = document.querySelectorAll(".form-item #link");
          if (linkElements[0].value !== "") {
            const urlString = linkElements[0].value;
            const urlRegex =
              /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
            const result = urlString.match(urlRegex);
            if (result !== null) {
              valid = true;
            } else {
              linkElements[0].parentElement.querySelector(
                ".input-error"
              ).innerText = "Please Enter a valid URL";
              valid = false;
            }
          }

          if (labelInp.value !== "" && linkInp.value !== "" && valid) {
            const formData = form.getData();
            this._insert(formData);
          }
        },
      },
    },

    start() {
      const buttonData = {
        title: this.lang.get("addbutton"),
        api: "plugin.addbutton.open",
      };
      this.toolbar.addButton("addbutton", buttonData);
    },

    open() {
      const options = {
        title: this.lang.get("addbutton"),
        width: "600px",
        name: "addbutton",
        handle: "insert",
        commands: {
          insert: { title: this.lang.get("insert") },
          cancel: { title: this.lang.get("cancel") },
        },
      };
      this.app.api("module.modal.build", options);
    },

    _insert(data) {
      this.app.api("module.modal.close");
      const button_label = data.cst_btn_label;
      const button_link = data.cst_btn_link;
      const button_color = data.cst_btn_color;

      const anchor = document.createElement("a");
      anchor.classList.add(button_color);
      anchor.innerText = button_label;
      anchor.href = button_link;
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "nofollow");

      const output = document.createElement("div");
      output.classList.add("editor-btn");
      output.append(anchor);

      const marker = this.marker.insert("start");
      const $marker = Redactor.dom(marker);
      $marker.before(output);
      this.selection.restoreMarkers();
    },
  });
})(Redactor);
